import styled, { css } from 'styled-components';

export const ProjectSettingsRowLinkStyled = styled.a<{ isDisabled: boolean }>`
  ${({ isDisabled }) =>
    isDisabled &&
    css`
      pointer-events: none;
    `};
`;

export const ProjectSettingsRowStyled = styled.div<{ muted: boolean }>`
  ${({ muted }) =>
    muted &&
    css`
      opacity: 0.5;
    `};
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
`;

export const ContentWrapper = styled.div`
  padding-left: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
`;
